import React from "react";
import { motion } from "framer-motion";

// Base shimmer block — a plain animated gradient sweep, not a spinner, so it
// can be shaped into whatever placeholder a given card needs (line, circle,
// image block) instead of forcing every loading state to look the same.
export const Skeleton = ({ className = "" }) => (
  <div className={`relative overflow-hidden rounded-lg bg-slate-200 ${className}`}>
    <motion.div
      className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/60 to-transparent"
      animate={{ x: ["-100%", "100%"] }}
      transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
    />
  </div>
);

// Matches HomeCollegeCarouselCard's shape (banner + logo + title + 4 stat
// chips) so the loading state doesn't visibly reflow into the real card.
export const SkeletonCollegeCard = () => (
  <div className="h-full rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm">
    <Skeleton className="h-28 sm:h-36 md:h-48 w-full rounded-none" />
    <div className="p-3 md:p-4 pt-5">
      <Skeleton className="h-6 w-3/4 mb-2" />
      <Skeleton className="h-4 w-1/2 mb-4" />
      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
        <Skeleton className="h-9" />
      </div>
    </div>
  </div>
);

// Matches CollegeListCard's compact/list shape.
export const SkeletonListCard = () => (
  <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm p-4 md:p-5">
    <div className="flex items-start gap-4">
      <Skeleton className="h-14 w-14 rounded-xl shrink-0" />
      <div className="flex-1 min-w-0">
        <Skeleton className="h-5 w-3/4 mb-2" />
        <Skeleton className="h-4 w-1/3 mb-3" />
        <div className="grid grid-cols-2 gap-2">
          <Skeleton className="h-10" />
          <Skeleton className="h-10" />
        </div>
      </div>
    </div>
  </div>
);

// Matches News.js's NewsCard shape.
export const SkeletonNewsCard = ({ featured = false }) => (
  <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
    <Skeleton className={"w-full rounded-none " + (featured ? "aspect-[16/9]" : "h-32 sm:h-36")} />
    <div className="p-4 md:p-5">
      <Skeleton className={"mb-2 " + (featured ? "h-6 w-5/6" : "h-5 w-full")} />
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  </div>
);

export default Skeleton;
